import React, { useState, useRef, useEffect } from "react";
import "./awb-tracking-page.css";
import FooterContent from "../footer-content/footer-content.js"; // Ensure you import FooterContent
import HeaderContent from "../header-content/header-content.js";
import TranslationFetcher from "./../translation-fetcher/translation-fetcher.js";
import { useNavigate } from "react-router-dom";

const AWBTrackingPage = ({ awbNumbers, locale, client, isDynamic, source, custcode }) => {
  const [currentPage, setCurrentPage] = useState(0); // State to hold the current page index
  const itemsPerPage = 10;
  const iframeRef = useRef(null);
  const observerRef = useRef(null);
  const navigate = useNavigate(); // Initialize useNavigate

  const handlePageChange = (pageIndex) => {
    setCurrentPage(pageIndex);
  };

  const handleNavigate = (event) => {
    event.preventDefault(); // Prevent the default anchor behavior
    if(source && source === 'home') {
      navigate(`/`); // Navigate to the dynamic route
    } else {
      navigate(`/${custcode}`);
    }
  };

  const resizeIframe = () => {
      if (iframeRef.current) {
        const iframeDocument = iframeRef.current.contentDocument || iframeRef.current.contentWindow.document;
    
        if (iframeDocument) {
          // Check if the observer is already set up
          if (!observerRef.current) {
            // Create a new MutationObserver instance
            const observer = new MutationObserver(() => {
              const newHeight = iframeDocument.body.scrollHeight + 32; // Add 32px to the height
              iframeRef.current.style.height = newHeight + 'px'; // Set the new height
            });
    
            // Start observing the body for changes
            observer.observe(iframeDocument.body, {
              childList: true,
              subtree: true,
            });
    
            // Store the observer in the ref for cleanup
            observerRef.current = observer;
          }
    
          // Set initial height if not set
          // const initialHeight = iframeDocument.body.scrollHeight > 0 ? (iframeDocument.body.scrollHeight + 32) : 100;
          // iframeRef.current.style.height = initialHeight + 'px';
          // console.log("Initial iframe height in awb result page is set to:", iframeDocument.body.scrollHeight );
        } else {
          console.warn("Unable to access iframe document in awb result page.");
        }
      } else {
        console.warn("iframeRef.current is null in awb result page.");
      }
    };
    
    // Cleanup function to disconnect the observer when the component unmounts or iframe source changes
    useEffect(() => {
      return () => {
        if (observerRef.current) {
          observerRef.current.disconnect();
          observerRef.current = null; // Clear the reference
        }
      };
    }, []);

  const { translationData, localePassed } = TranslationFetcher({ locale });
  const countryCode = translationData?.ctryCd;
  const myDHLCtryCd = translationData?.myDHLCtryCd;
  const myDHLCtryLocale = translationData?.myDHLCtryLocale;

  const startIndex = currentPage * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentAwbNumbers = awbNumbers.slice(startIndex, endIndex);
  const backendUrl = window.env.BACKEND_URL ? window.env.BACKEND_URL : window.location.origin;
  // Construct the tracking URL with the current page's AWB numbers
  const trackingUrl = currentAwbNumbers.length > 0
    ? `${backendUrl}/reverse/${myDHLCtryCd}/${myDHLCtryLocale}/tracking.html?isDynamic=${isDynamic}&type=1#/results?` +
      currentAwbNumbers.map(awb => `id=${awb}`).join('&') 
    : null;
  // Calculate total pages
  const totalPages = Math.ceil(awbNumbers.length / itemsPerPage);

  return (
    <div className="outer-body-container text-02">
      <HeaderContent toDisplayClientLogo={true} client={client} currentPage="resultsPage" locale={localePassed} countryCode={countryCode}/>
      <div className="body-content">
        {/* <div className="column-results"></div> */}
        <div className="box-results">
          <div className="contentbody">
            <div className="bold-text">
              <p>{translationData?.translations.resultTitle}</p>
              <p>{translationData?.translations.resultDesc}</p>
            </div>
            {trackingUrl && (
              <iframe
                ref={iframeRef}
                title="Tracking Results"
                src={trackingUrl}
                style={{ width: "100%", minHeight: "calc(100vh - 305px)" , height: "calc(100vh - 305px)", border: "none" }} // Set a static height initially
                frameBorder="0"
                onLoad={resizeIframe}
              />
            )}
            <div className="col-6">
              <button className="back-to-search-button text-02" onClick={handleNavigate} >
                Back to Search
              </button>
            </div>
            {/* Pagination Controls */}
            {totalPages > 1 && (
              <div className="pagination-controls">
                {Array.from({ length: totalPages }, (_, index) => (
                  <button
                    key={index}
                    onClick={() => handlePageChange(index)}
                    className={currentPage === index ? "active" : ""}
                  >
                    {index + 1}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
        {/* <div className="column-results"></div> */}
      </div>

      <FooterContent />
    </div>
  );
};

export default AWBTrackingPage;